
import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';

const HeaderSearch = () => {
  const [searchExpanded, setSearchExpanded] = useState(false);
  
  return (
    <div className={`flex items-center transition-all duration-200 ${searchExpanded ? 'w-64' : 'w-auto'}`}>
      {searchExpanded ? (
        <div className="relative w-full">
          <Input 
            type="text" 
            placeholder="Search..." 
            className="pr-8"
            autoFocus
            onBlur={() => setSearchExpanded(false)}
          />
          <button 
            className="absolute right-2 top-1/2 transform -translate-y-1/2"
            onClick={() => setSearchExpanded(false)}
          >
            <X size={16} className="text-muted-foreground" />
          </button>
        </div>
      ) : (
        <button 
          className="p-2 rounded-full hover:bg-[#F5F5F7] transition-colors duration-200"
          onClick={() => setSearchExpanded(true)}
          aria-label="Search"
        >
          <Search size={20} className="text-[#1A2033]" />
        </button>
      )}
    </div>
  );
};

export default HeaderSearch;
